(() => {
  const initializeFaqAccordions = (root) => {
    root.querySelectorAll('[data-alard-faq-item]').forEach((item) => {
      if (item.dataset.alardFaqInitialized === 'true') return;
      item.dataset.alardFaqInitialized = 'true';

      const summary = item.querySelector('[data-alard-faq-summary]');
      const answer = item.querySelector('[data-alard-faq-answer]');
      if (!summary || !answer) return;

      summary.setAttribute('aria-expanded', String(item.open));
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (item.dataset.alardFaqAnimating === 'true') return;

        const shouldOpen = !item.open;
        summary.setAttribute('aria-expanded', String(shouldOpen));

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof item.animate !== 'function') {
          item.open = shouldOpen;
          return;
        }

        item.dataset.alardFaqAnimating = 'true';
        item.classList.toggle('is-closing', !shouldOpen);
        const collapsedHeight = summary.offsetHeight;
        let startHeight = item.offsetHeight;
        let endHeight = collapsedHeight;

        if (shouldOpen) {
          item.open = true;
          endHeight = item.offsetHeight;
          startHeight = collapsedHeight;
        }

        item.style.height = `${startHeight}px`;
        item.style.overflow = 'hidden';

        const itemAnimation = item.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: 280, easing: 'cubic-bezier(.22, 1, .36, 1)' },
        );
        answer.animate(
          { opacity: shouldOpen ? [0, 1] : [1, 0] },
          { duration: shouldOpen ? 240 : 180, easing: 'ease-out' },
        );

        itemAnimation.addEventListener(
          'finish',
          () => {
            item.open = shouldOpen;
            item.style.removeProperty('height');
            item.style.removeProperty('overflow');
            item.classList.remove('is-closing');
            delete item.dataset.alardFaqAnimating;
          },
          { once: true },
        );
      });
    });
  };

  document.querySelectorAll('[data-alard-faq-list]').forEach(initializeFaqAccordions);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-alard-faq-list]').forEach(initializeFaqAccordions);
  });
})();
